import { IPackageProgramItem } from 'services/shop/types/package-program';
import { ChipButton, ChipGrid } from './styles';

type Props = {
  programs: IPackageProgramItem[];
  selectedId?: string;
  onSelect: (programId: string) => void;
};

// Hàng chip chọn program; mỗi chip là một program trong api package-program/list
const PackageProgramChips = ({ programs, selectedId, onSelect }: Props) => (
  <ChipGrid>
    {programs.map((program) => (
      <ChipButton
        key={program.id}
        type='button'
        className={program.id === selectedId ? 'active' : ''}
        onClick={() => onSelect(program.id)}
      >
        <span className='chip-label'>{program.name}</span>
      </ChipButton>
    ))}
  </ChipGrid>
);

export default PackageProgramChips;
